import Cookies from 'js-cookie';
import type {
  PageContext,
} from 'vike/types';
import Storage from '@dinosave/core/storage';
import {
  getAlertsStore,
  getApplicationStore,
  getAuthenticationStore,
  getSettingsStore,
  getUsersStore,
  getFriendshipsStore,
  getItemsStore,
  getWishlistsStore,
  getPriceDropsStore,
  getDomainsStore,
  getEmailsStore,
  getFeedbacksStore,
} from '@dinosave/core/stores';

const STORES_MAP = {
  'alertsStores': getAlertsStore,
  'applicationStores': getApplicationStore,
  'authenticationStores': getAuthenticationStore,
  'settingsStores': getSettingsStore,
  'usersStores': getUsersStore,
  'friendshipsStores': getFriendshipsStore,
  'itemsStores': getItemsStore,
  'wishlistsStores': getWishlistsStore,
  'priceDropsStores': getPriceDropsStore,
  'domainsStores': getDomainsStore,
  'emailsStores': getEmailsStore,
  'feedbacksStores': getFeedbacksStore,
};

let hydrated = false;

const onCreatePageContext = (pageContext: PageContext) => {
  const {
    stores,
  } = pageContext;

  if (
    hydrated
  ) return;

  hydrated = true;

  Object
    .entries(stores)
    .forEach(([storeKey, stores]) => {
      const getStore = STORES_MAP[storeKey];
      if (
        !getStore
      ) return;

      Object
        .entries(stores)
        .forEach(([key, storeState]) => {
          getStore(key).setState(storeState);
        });
    });

  const applicationStore = getApplicationStore();

  applicationStore.setState({
    storage: new Storage(Cookies),
    apiURL: String(import.meta.env.PUBLIC_ENV__API_URL),
    corsURL: String(import.meta.env.PUBLIC_ENV__CORS_URL),
  });

  // console.log('Hydrate Zustand stores...', stores);
};

export default onCreatePageContext;
